var link_viewer_default = {
  "fontElementMap": "iNw-m",
  "link": "OHs8-",
  "linkInEditor": "J29SL",
  "linkInViewer": "IyRpB",
  "toolbarUrlContainer": "pkvC0",
  "toolbarUrl": "aMFj6",
  "toolbarUrlAnchor": "JWnet"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
